import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { refreshSyncAccountAlgoData } from "../../Services/apiService";
import { prependNewsFeedPost } from "../../utility/newsFeedPost";
import { motion } from "framer-motion";
import Comment from "./Comment";
import CommentAction from "./CommentAction";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Col, Modal, Row } from "react-bootstrap";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { post } from "../../config/imagesLink";
import ModalForGuest from "../ModalForGuest";
import ThumbUpAltSharpIcon from "@mui/icons-material/ThumbUpAltSharp";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ChatSharpIcon from "@mui/icons-material/ChatSharp";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkOutlinedIcon from "@mui/icons-material/BookmarkOutlined";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import moment from "moment";
import { Link } from "react-router-dom";
import PostComponent from "./PostComponent";
import ReactQuill from "react-quill";
import { customStyles } from "../../selectStyles";
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import Select from "react-select";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";

const { likegif } = post;

const PostEngagement = ({
  item,
  postId,
  AllPostList,
  postList,
  setPage,
  setPostList,
  page,
  setTotalPages,
  totalPages,
  setDLike,
  updateLikeCount,
  updatePostLike,
  updateShareCount,
  openModal,
  setSinglePostContent,
  setSinglePostId,
  setIspostmodalOpen,
  ispostmodalOpen,
  emojiList,
  isSavedPage,
  // restrictedViewerToken,
  commentModalBlockedMessage,
}) => {
  const [showComments, setShowComments] = useState(false);
  console.log("engage postId", item);
  const guestModeData = localStorage.getItem("guestMode");
  const { t } = useTranslation();

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const getApiErrorMessage = (error) => {
    return (
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong. Please try again."
    );
  };

  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [imageArray, setImageArray] = useState([]);

  const [privacyType, setPrivacyType] = useState(t("Public"));
  const Privacy = [
    // { value: "Public", label: "Public", icon: <PublicSharpIcon /> },
    // { value: "Friends", label: "Friends", icon: <GroupSharpIcon /> },
    // { value: "OnlyMe", label: "OnlyMe", icon: <LockSharpIcon /> },
    // { value: "Custom", label: "Custom", icon: <TuneSharpIcon /> },
        { value: "Public", label: t("Newsfeed.Public") , icon: <PublicSharpIcon /> },
        { value: "Friends", label: t("Newsfeed.Friends") , icon: <GroupSharpIcon /> },
        { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
        { value: "Custom", label: t("Newsfeed.Custom") , icon: <TuneSharpIcon /> },
  ];
  const [postContent, setPostContent] = useState("");
  const [postID, setPostID] = useState("");
  const [display, setDisplay] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const handlePaste = (e) => {
    const isCtrlV = e.ctrlKey && e.key === "v";

    if (isCtrlV) {
      e.preventDefault();
      alert("Please use Ctrl + Shift + V to paste.");
    }
  };

  const toggleComments = () => {
    setShowComments(!showComments);
  };

  const handleCommentClick = () => {
    if (commentModalBlockedMessage) {
      setWarningToastMessage(commentModalBlockedMessage);
      setShowWarningToast(true);
      return;
    }

    if (Array.isArray(item?.postInfo?.mediaFilesList)) {
      openModal(item?.postInfo?.mediaFilesList.map((file) => file.mediaName));
    } else {
      openModal([]);
    }

    setSinglePostContent(item);
    setIspostmodalOpen(true);
    setSinglePostId(item?.postInfo?.postId);
  };
  // console.log(showComments);

  console.log("Postitem", item);
  const sessionId = localStorage.getItem("sessionId");
  const videoToken = localStorage.getItem("restrictedViewerToken");
  console.log("videoToken22222", videoToken);
  //************************Save Post start   ************************// 
  const [isSaved, setIsSaved] = useState(item?.postInfo?.postActionsInfo?.isSaved);


  const savePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    console.log("responseData", responseData);
    try {
      await axios.post(`PostAction/SavePost`, responseData).then((res) => {
        console.log("save post", res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setIsSaved(true); 
      });
      // -------------------------------------------
      setPostList((prevPosts) =>
        prevPosts.map((post) =>
          post.postInfo.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                postActionsInfo: { ...post.postInfo.postActionsInfo, isSaved: true },
              },
            }
            : post
        )
      );
      // -------------------------------------------
    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save Post End  ************************//

  //************************UnSave Post start  ************************//
  const unsavePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      const res = await axios.post(`PostAction/UnsavePost`, responseData);

      setToastMessage(res.data.message);
      setShowToast(true);
      setIsSaved(false);

      // If this component is rendered on the Saved page, remove the post
      // immediately from the UI and update paging/counts so the list
      // reflects the unsave action without requiring a full reload.
      if (isSavedPage) {
        try {
          setPostList((prev = []) => {
            const updated = prev.filter(
              (post) => post?.postInfo?.postId !== postId
            );
            const newTotalPosts = updated.length;
            const pageSize = 8; // Saved page uses pageSize = 8
            const newTotalPages = newTotalPosts === 0 ? 1 : Math.ceil(newTotalPosts / pageSize);
            setTotalPages(newTotalPages);
            if (page > newTotalPages) setPage(newTotalPages);
            return updated;
          });
        } catch (e) {
          console.log("Error updating saved list after unsave:", e);
        }

        // Refresh profile/stat counts if a refresh function was passed in
        try {
          if (typeof AllPostList === "function") AllPostList();
        } catch (e) {}
      }

    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnSave Post End  ************************//

  //************************like Post start  ************************//
  const [selectedImg, setSelectedImage] = useState("");
  const [isLiking, setIsLiking] = useState(false);
  // const [isLiked, setIsLiked] = useState(false);
  const [likedType, setLikedType] = useState(null);
  const [changeLikedType, setChangeLikedType] = useState(null);
  // Local per-post like state to avoid a global boolean affecting all posts
  const [isLikedLocal, setIsLikedLocal] = useState(
    !!item?.postInfo?.postActionsInfo?.isLiked
  );

  useEffect(() => {
    setIsLikedLocal(!!item?.postInfo?.postActionsInfo?.isLiked);
  }, [item?.postInfo?.postActionsInfo?.isLiked]);

  const LikePost = async (liketype, imageName) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      likeType: liketype,
            langKey: language === "en" ? "" : language,

    };
    // console.log(responseData);
    setIsLiking(true);
    setLikedType(liketype);

    setTimeout(async () => {
      try {
        await axios.post(`PostAction/LikePost`, responseData).then((res) => {
           setToastMessage(res?.data?.message);
          setShowToast(true); 
          setSelectedImage(imageName);
          setIsHovered(false);
          setIsLiking(false);
          setIsLikedLocal(true);
          setLikedType(liketype);
          // setDLike(1)
          // update global like count and postActionsInfo
          updateLikeCount(postId, 1);
          if (typeof updatePostLike === "function") {
            updatePostLike(postId, 0, true, liketype);
          }
        });
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response?.data?.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response?.data?.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };

  const ReLikePost = async (liketype, imageName) => {
    try {
      const currentLikedType =
        likedType ??
        changeLikedType ??
        item?.postInfo?.postActionsInfo?.likedType;

      if (Number(currentLikedType) === Number(liketype)) {
        setIsHoveredRelike(false);
        return;
      }

      const responseData = {
        deviceType: "Web",
        sessionId: sessionId,
        postId: postId,
        likeType: liketype,
              langKey: language === "en" ? "" : language,

      };
      // console.log(responseData);
      setIsLiking(true);
      setLikedType(liketype);

      const res = await axios.post("/PostAction/ChangeLikeType", responseData);

      console.log("likedTyphgjhhje", res, item.likedType);
      // toast.success('gdhghdg', res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      // AllPostList();
      setSelectedImage(imageName);
      setIsHoveredRelike(false);
      setIsLiking(false);
      setIsLikedLocal(true);
      setLikedType(liketype);
      setChangeLikedType(liketype);
      if (typeof updatePostLike === "function") {
        updatePostLike(postId, 0, true, liketype);
      }
    } catch (e) {
      console.log(e);
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************like Post End  ************************//
  //************************unlike Post start  ************************//
  const UnLikePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    // console.log(responseData);
    setIsLikedLocal(false);
    setLikedType(null);
    updatePostLike(postId, -1, false, null);
    try {
      const res = await axios.post(`PostAction/UnlikePost`, responseData);
      // .then((res) => {
      // console.log(res);
      // toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true); 
      setIsHovered(false);
      setIsHoveredRelike(false);
      setIsLikedLocal(false);
      setLikedType(null);
      // setDLike(-1)
      updateLikeCount(postId, -1);
      // console.log("hghdgshgd", likedType, item.likedType);

      // const postDetailsResponse = await axios.get(
      //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}`
      // );
      // console.log("postDetailsResponse", postDetailsResponse);
      // const updatedPost = postDetailsResponse.data.responseData;
      // console.log("updatedPost", updatedPost);

      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
      // Update the existing post in the list
      // setPostList(updatedPost)

      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postInfo.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
    } catch (e) {
      setIsLikedLocal(true);
      setLikedType(item?.postInfo?.postActionsInfo?.likedType); // Revert to previous liked type
      // Revert parent like count/state
      updateLikeCount(postId, 1);
      if (typeof updatePostLike === "function") {
        updatePostLike(
          postId,
          0,
          true,
          item?.postInfo?.postActionsInfo?.likedType
        );
      }
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************unlike Post End  ************************//
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredRelike, setIsHoveredRelike] = useState(false);
  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };

  const [shareModal, setShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState();
  const sharePost = async () => {
    const sharePost = {
      deviceType: "Web",
      id: postId,
      type: 1,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("SMFeatures/SaveShareURL", sharePost).then((res) => {
        console.log("share", res);
        setShareUrl(res.data.responseData.value);
        updateShareCount(postId, 1);
        // setToastMessage(res.data.message);
        // setShowToast(true);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleLike = () => {
    // console.log("likes is pressed");
  };

  // useEffect(() => {
  //   if (shareModal) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //     document.body.classList.add("modal-open"); // When a modal opens
  //   } else {
  //     document.body.style.overflow = "unset";
  //     document.documentElement.style.overflow = "";
  //     document.body.classList.remove("modal-open"); // When a modal closes
  //   }
  // }, [shareModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

  //Create Post
  //Post create logic
  const [images, setImages] = useState([]);
  const editorRef = useRef(null);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [SearchText, setSearchText] = useState("")
  const userUid = localStorage.getItem("userUid");

  const handleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setPostContent(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value?.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleSubmit = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const payload = {
        DeviceType: "Web",
        sessionId: sessionId,
        PrivacyType: privacyType || "Public",
        PostOriginType: "User",
        originPostId: postId,
        PostOriginID: userUid,
        PostCategory: "SharePost",
        PostContent: postInputValue ? postInputValue : postContent,
        DynamicValues: postDynamicValues,
              langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("/Posts/SharePost", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("frfrfrf", res);
      
      setToastMessage(res?.data?.message );
      setShowToast(true);
      // setShareModal(false);
      // AllPostList();
      setPostDynamicValues([]);
      setPostInputValue("");
      const newPostId = res?.data?.responseData?.id;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );
      const newPost = postDetailsResponse?.data?.responseData?.postInfo;
      setPostList((prev) => prependNewsFeedPost(prev, newPost));
      refreshSyncAccountAlgoData().catch(() => {});
      console.log("postinfoshared", newPost);

      setPostContent("");
      // setImages([])D;
      setPostID("");
      // setShowSecondModal(false);
      setIsloading(false);
      setTimeout(() => {
        setShareModal(false);
      }, 300);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      console.log("newPostId", error);
      const errorMessage = getApiErrorMessage(error);
      if (error?.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };

  const videoRef = useRef(null);


  useEffect(() => {
    if (!openModal) return;

    const waitForRef = () => {
      const currentVideoRef = videoRef.current;
      if (!currentVideoRef) {
        requestAnimationFrame(waitForRef);
        return;
      }

      const videoId = item?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
      const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken });

      const hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(currentVideoRef);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const plyrInstance = new Plyr(currentVideoRef, {
          captions: { active: true, update: true, language: "en" },
        });
        currentVideoRef.play().catch(err => console.warn("Play failed", err));
      });
    };

    waitForRef();
  }, [openModal, item, restrictedViewerToken]);

  const handlePostEngagementEscape = useCallback(() => {
    if (showSuggestions) {
      setShowSuggestions(false);
      return;
    }
    if (shareModal) {
      setShareModal(false);
    }
  }, [showSuggestions, shareModal]);

  useEscapeKeyDown(shareModal, handlePostEngagementEscape);

  return (
    <>
      <div className="d-flex justify-content-between pt-1">
        <div className="d-flex align-items-center postAction likeActions ms-2">
          {console.log("changeLikedType", isLikedLocal, likedType, changeLikedType)}

          {isLikedLocal === true || item?.postInfo?.postActionsInfo?.isLiked === true ? (
            <motion.div
              className="like-container pointer d-flex align-items-center"
              onClick={() => UnLikePost()}
              whileHover={{ scale: 1.3 }}
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
            >
              {item?.postInfo?.postActionsInfo?.likedType === 1 ||
                likedType === 1 ||
                changeLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : item?.postInfo?.postActionsInfo?.likedType === 2 ||
                likedType === 2 ||
                changeLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : item?.postInfo?.postActionsInfo?.likedType === 3 ||
                likedType === 3 ||
                changeLikedType === 3 ? (
                <>
                  <img src={post.LaughingGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : item?.postInfo?.postActionsInfo?.likedType === 4 ||
                likedType === 4 ||
                changeLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : item?.postInfo?.postActionsInfo?.likedType === 5 ||
                likedType === 5 ||
                changeLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              )}
            </motion.div>
          ) : isLiking ? (
            (console.log("likedType", likedType),
              likedType === 1 || changeLikedType === 1 ? (
                <>
                  {/* <img src={post.LikeGif} width={30} /> */}
                  <img src={likegif} alt="loading" width={50} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : likedType === 2 || changeLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : likedType === 3 || changeLikedType === 3 ? (
                <>
                  <img src={post.LaughingGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : likedType === 4 || changeLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : likedType === 5 || changeLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  {/* <img src={post.LikeGif} width={30} /> */}
                  <img src={likegif} alt="loading" width={50} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ))
          ) : (
            <>
              {guestModeData === "true" ? (
                <div className="d-flex align-items-center">
                  <motion.span
                    className="pointer pe-1 "
                    onClick={() => {
                      setFollowModal(true);
                    }}
                  >
                    <ThumbUpAltOutlinedIcon />
                  </motion.span>
                  <p
                    className="f-12 pointer ms-1"
                    onClick={() => {
                      setFollowModal(true);
                    }}
                  >
                   {t("Newsfeed.Like")}
                    {/* Like */}
                  </p>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <motion.span
                    whileHover={{ scale: 1.3 }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                      LikePost(1, "Like");
                    }}
                    className="pointer  pe-1"
                  >
                    <ThumbUpAltOutlinedIcon />
                  </motion.span>
                  <motion.p
                    className="f-12 pointer ms-1"
                    whileHover={{ scale: 1.3 }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                      LikePost(1, "Like");
                    }}
                  >
                    {t("Newsfeed.Like")}
                  </motion.p>
                </div>
              )}
            </>
          )}
          {isHovered && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        LikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
          {isHoveredRelike && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        ReLikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
        </div>
        {ispostmodalOpen === undefined ||
          ispostmodalOpen === true ||
          guestModeData === "true" ? (
          <div className="d-flex align-items-center postAction">
            <ChatOutlinedIcon
              className="pointer"
              onClick={() => {
                setFollowModal(true);
              }}
            />
            <p
              className="f-12 pointer ms-1"
              onClick={() => {
                setFollowModal(true);
              }}
            >
              {/* Comment */}
              {t("Newsfeed.Comment")}
            </p>
          </div>
        ) : (
          <div
            className="d-flex align-items-center postAction"

            onClick={handleCommentClick}

          >
            <ChatOutlinedIcon className="pointer" />
            <p className="f-12 pointer ms-1">{t("Newsfeed.Comment")}</p>
            {/* <p className="f-12 pointer ms-1">Comment</p> */}
          </div>
        )}

          {guestModeData === "true" ? (
      
        <div className="d-flex align-items-center postAction">
          <ShareOutlinedIcon
            onClick={() => {
                setFollowModal(true);
              }}
            className="pointer"
          />
          <p
            className="f-12 pointer ms-1"
            onClick={() => {
                setFollowModal(true);
              }}
          >
            {t("Newsfeed.Share")}
            {/* Share */}
          </p>
        </div>
) : (
   <div className="d-flex align-items-center postAction">
          <ShareOutlinedIcon
            onClick={(e) => {
              e.preventDefault();
              setShareModal(true);
              sharePost();
            }}
            className="pointer"
          />
          <p
            className="f-12 pointer ms-1"
            onClick={(e) => {
              e.preventDefault();
              setShareModal(true);
              sharePost();
            }}
          >
            {t("Newsfeed.Share")}
            {/* Share */}
          </p>
        </div>
      )
}        

        {/* {console.log("isSaved", item, item?.postInfo?.postActionsInfo?.isSaved)} */}

        {guestModeData === "true" ? (
          <div className="d-flex align-items-center postAction">

            <BookmarkBorderOutlinedIcon
              className=" material-symbols-outlined pointer"
              onClick={() => {
                setFollowModal(true);
              }}
              disabled={guestModeData === "true"}
            />
            <p
              className="f-12 pointer ms-1"
              onClick={() => {
                setFollowModal(true);
              }}
            >
              {t("Newsfeed.Save")}
              {/* Save */}
            </p>
          </div>
        ) : isSaved ? (
          <div className="d-flex align-items-center postAction">

            <BookmarkOutlinedIcon
              onClick={() => {
                unsavePost();
              }}
              className="material-symbols-sharp pointer"
            />
            <p
              className="f-12 pointer ms-1"
              onClick={() => {
                unsavePost();
              }}
            >
              {t("Newsfeed.Save")}
              {/* Saved */}
            </p>
          </div>
        ) : (
          <div className="d-flex align-items-center postAction">

            <BookmarkBorderOutlinedIcon
              className="pointer"
              onClick={() => {
                savePost();
              }}
            />
            <p
              className="f-12 pointer me-1"
              onClick={() => {
                savePost();
              }}
            >
              {t("Newsfeed.Save")}
              {/* Save */}
            </p>
          </div>
        )}
      </div>

      {ispostmodalOpen === undefined || ispostmodalOpen === true ? (
        <Comment
          item={item}
          isOwnedPost={item?.postInfo?.isOwned}
          postId={item?.postInfo?.postId}
          AllPostList={AllPostList}
          postList={postList}
          setPage={setPage}
          setPostList={setPostList}
          page={page}
          setTotalPages={setTotalPages}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      
      {followModal && <ModalForGuest closeModalData={closeModalData} />}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {shareModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex flex-column p-2">
              {/* Modal Header */}
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{item.cntntTypCategory === "TextWithVideo" || item.cntntTypCategory === "Video" ? `${t("Newsfeed.Share Video Post")}` : `${t("Newsfeed.Share Post")}`}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-0 pointer"
                  onClick={() => setShareModal(false)}
                />
              </div>

              {/* Share Buttons */}
              <div className="my-4 d-flex justify-content-between px-4">
                <FacebookShareButton
                  url={shareUrl}
                  onClick={() => setShareModal(false)}
                >
                  <FacebookIcon className="ShareIcon" />
                </FacebookShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <WhatsappIcon className="ShareIcon" />
                </WhatsappShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <LinkedinIcon className="ShareIcon" />
                </LinkedinShareButton>
                {/* <TwitterShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <TwitterIcon className="ShareIcon" />
                </TwitterShareButton> */}
                <TwitterShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <div className="ShareIcon d-flex align-items-center justify-content-center" style={{backgroundColor:"black"}}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                      <path d="M18.244 2H21.5l-7.45 8.51L22 22h-6.828l-5.345-6.993L3.95 22H.692l7.97-9.104L2 2h7l4.83 6.338L18.244 2Zm-2.396 18h1.889L8.11 3.889H6.083L15.848 20Z"/>
                    </svg>
                  </div>
                </TwitterShareButton>
              </div>

              <div
                className=" postAdd"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div className=" " role="document">
                  <div className="modal-content d-flex justify-content-around">
                    <div className=" modalBorder d-flex justify-content-between align-items-center p-2">
                      <h6>{t("Newsfeed.Post Something on")}</h6>
                      {/* <input type="checkbox" />
                      My Timeline */}
                      <Select
                        defaultValue={Privacy.find(
                          (option) => option.value === privacyType
                        )}
                        onChange={(selectedOption) => {
                          setPrivacyType(selectedOption.value);
                        }}
                        options={Privacy}
                        placeholder={t("Newsfeed.Select Privacy")}
                        styles={customStyles}
                        formatOptionLabel={({ label, icon }) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {icon}
                            <span style={{ marginLeft: 8 }}>{label}</span>
                          </div>
                        )}
                      />
                    </div>
                    <div className="m-3">
                      <div className="post-editor-container">
                        <ReactQuill
                          ref={editorRef}
                          value={postContent}
                          onChange={(content, delta, source, editor) => {
                            handleChange(content, delta, source, editor);
                          }}
                          placeholder={t("Newsfeed.What do you want to talk about?")}
                          // placeholder="What do you want to talk about?"
                          modules={{ toolbar: false }}
                        />

                        {showSuggestions && (
                          <ul className="suggestion-box">
                            {mentionType === "Hashtag" ? <li
                              onMouseDown={(e) => {
                                e.preventDefault(); // Prevent editor blur
                                insertMention(
                                  SearchText,
                                  null
                                );
                              }}
                              className="suggestion-item"
                            >
                              <span>{SearchText ? `#${SearchText}` : ''}</span>
                            </li> : null}
                            {suggestions?.map((item, index) => (
                              <li
                                key={index}
                                onMouseDown={(e) => {
                                  e.preventDefault(); // Prevent editor blur
                                  insertMention(
                                    mentionType === "UserMention"
                                      ? item?.entityName
                                      : item?.hashTag,
                                    mentionType === "UserMention"
                                      ? item?.userUid
                                      : null
                                  );
                                }}
                                className="suggestion-item"
                              >
                                {mentionType === "UserMention" ? (
                                  <>
                                    <img
                                      src={item?.avatar}
                                      alt={item?.entityName}
                                      className="avatar"
                                    />
                                    <span>{item?.entityName}</span>
                                  </>
                                ) : (
                                  <span>#{item?.hashTag}</span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {/* <div className="modal-border d-flex justify-content-center align-items-center">
                      <input
                        id="fileInput"
                        type="file"
                        onChange={imageSelect}
                        style={{ display: "none" }}
                        ref={inputFileRef}
                        multiple
                      />

                      {images.length > 0 && (
                        <div className="post-selected d-flex justify-content-center flex-wrap">
                          {images.map((image, index) => (
                            <div key={index} className="position-relative m-2">
                              <img
                                src={image.url}
                                alt={`Selected Image ${index}`}
                                style={{
                                  maxWidth: "200px",
                                  maxHeight: "300px",
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                onClick={() => removeImage(index)}
                                className="btn btn-danger position-absolute top-0 end-0"
                                style={{
                                  transform: "translate(50%, -50%)",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "0",
                                }}
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div> */}

                    <div className="m-3 d-flex align-items-center">
                      <form className="form" action="#" method="post" id="form">
                     
                      </form>
                      {/* <WorkOutlineSharpIcon className="pointer me-2" onClick={(e) => {
                                guestModeData === "true"
                                  ? setShowJobDraftModal(false)
                                  : openJobDraftModal();
                              }} /> */}
                      {/* <WorkOutlineSharpIcon
                        className="pointer me-2"
                        onClick={(e) => {
                          if (guestModeData === "true") {
                            setShowJobDraftModal(false);
                          } else if (ownCompanyList === "0") {
                            openWarningModal();  
                          } else {
                            openJobDraftModal();  
                          }
                        }}
                      /> */}

                      {/* <FaRegPenToSquare
                        className="pointer me-2"
                        onClick={(e) => {
                          if (guestModeData === "true") {
                            return;
                          }

                          closeModal();
                          setTimeout(() => {
                            openArticleModal();
                          }, 100);
                        }}
                      /> */}
                    </div>

                    <div
                      className="card-body d-flex flex-wrap justify-content-start"
                      id="container"
                    >
                      {/* {renderImages()} */}
                    </div>
                  </div>
                </div>
              </div>

              {/* <Link
                to={
                  item?.postOriginType === "Company"
                    ? `/Company/${item?.userUid}`
                    : `/User/${item.userUid}`
                }
              > */}
              <div className="d-flex align-items-center mt-4">
                <div className="ImgAvatar">
                  <img
                    src={item?.postInfo?.userAvatar}
                    alt=""
                    style={{ borderRadius: "50px" }}
                  />
                </div>

                <div className="ms-2">
                  <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName} </h4>
                  <p className="f-12">{item?.postInfo?.title}</p>
                  <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                  {/* <p className="f-10 label">
                    {moment
                      .utc(item?.postInfo?.creationTime)
                      .local()
                      .format("DD MMMM YYYY [at] h:mm a")}
                  </p> */}
                </div>
              </div>
              {/* </Link> */}
              <PostComponent item={item} restrictedViewerToken={restrictedViewerToken} />
              <div
                className="feed-post"
                style={{
                  paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                }}
              >
                <div className="row">
                  {item?.postInfo?.mediaFilesList?.slice(0, 4)?.map((file, idx) => (
                    <div
                      key={idx}
                      className={`col-${item?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
                        } ${item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                          ? "col-12"
                          : ""
                        }`}
                      onClick={() => {
                        setInitialSlideIndex(idx);
                        setImageArray(item?.postInfo?.mediaFilesList);
                        // console.warn("===========1============>>", idx);
                        let imageData = item?.postInfo?.mediaFilesList.map(
                          (file) => file.mediaName
                        );
                        openModal(imageData, idx);
                        setSinglePostContent(item);
                        setSinglePostId(item?.postInfo?.postId);
                      }}
                      style={{
                        position: "relative",
                        padding:
                          item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                            ? "0 0 5px 0"
                            : item?.postInfo?.mediaFilesList.length === 3 && idx === 1
                              ? "0 5px 5px 0"
                              : item?.postInfo?.mediaFilesList.length === 4 && idx === 2
                                ? "0 5px 0 0"
                                : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
                                  ? "0 5px 5px 0"
                                  : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
                                    ? "0 5px 5px 0"
                                    : "",
                      }}
                    >
                      {/* <img
                        src={file.mediaName}
                        alt=""
                        className="img-fluid"
                        width={"100%"}
                      /> */}
                      {file.mediaType === "Image" ? (
                        <img
                          src={`${file.mediaName}`}
                          alt=""
                          className="img-fluid"
                          width="100%"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = post.noimgavailable;
                          }}
                          style={{ maxHeight: '300px' }}
                        />
                      ) : (
                        // <video
                        //   controls
                        //   src={file.mediaName}
                        //   className="img-fluid"
                        //   width="100%"
                        // />
                        // <iframe
                        //   style={{
                        //     paddingBottom: '50px', marginTop: '-1px',
                        //   }}
                        //   width="100%"
                        //   height="300"
                        //   //src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                        //   frameBorder="0"
                        //   allow="autoplay"
                        //   allowFullScreen

                        // />
                        <video
                          ref={videoRef}
                          controls
                          autoPlay={false}
                          muted
                          width="100%"
                          height="300"
                          playsInline
                          className="video-js"
                          style={{ backgroundColor: "#000", maxHeight: "300px" }}
                        />

                      )}
                      {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                          +{item?.postInfo?.postMediaCount - 4}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {guestModeData === "true" ? (
                  ""
                ) : (
                  <div className="row comment-gradient">
                    <div
                      className="addComment"
                      onClick={() => {
                        setInitialSlideIndex(1);
                        setImageArray(item?.postInfo?.mediaFilesList);
                        let imageData = item?.postInfo?.mediaFilesList.map(
                          (file) => file.mediaName
                        );
                        openModal(imageData, 1);
                        setSinglePostContent(item);
                        setSinglePostId(item?.postInfo?.postId);
                      }}
                    >
                      {/* <div
                        className="postCommentWrapper"
                        onClick={(event) => event.stopPropagation()}
                      >
                        <PostComment
                          item={item}
                          postId={item?.postId}
                          AllPostList={AllPostList}
                          postList={postList}
                          setPage={setPage}
                          setPostList={setPostList}
                          page={page}
                          setTotalPages={setTotalPages}
                          totalPages={totalPages}
                          updateCommentCount={updateCommentCount}
                          ispostmodalOpen={ispostmodalOpen}
                          setIspostmodalOpen={setIspostmodalOpen}
                        />
                      </div> */}
                    </div>
                  </div>
                )}
              </div>

              <button
                className="mainBtn ms-auto my-2"
                disabled={isloading}
                onClick={handleSubmit}
              >
                {isloading === true ? `${t("Newsfeed.Sharing")}` : `${t("Newsfeed.Share")}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PostEngagement;
